<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h2 class="u">Добавить подъезд</h2>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'building-details', params: { building_id: $route.params.building_id } }">← Назад к Подъездам</router-link>
    </div>

    <block-add-form :building="+$route.params.building_id" @after="handleAfter" />

  </div>
</template>

<script>
import blockAddForm from '@/components/forms/block/BlockAddForm'

export default {
  name: 'block-add',
  components: { blockAddForm },
  methods: {
    handleAfter (success) {
      if (success) {
        this.$router.push({ name: 'building-details', params: { building_id: this.$route.params.building_id } })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// BlockAdd.vue?027c8098